import React, { useContext } from "react";
import { CoreValuesContext } from "../../App";
import parse from "html-react-parser";
import { Users, Award, TrendingUp, CheckCircle2 } from "lucide-react";

const Aboutcard = () => {
  const coreValues = useContext(CoreValuesContext);

  function findOurMission(items: any[]) {
    if (!Array.isArray(items)) return null;
    return (
      items.find((item) => item?.title?.toLowerCase?.().includes("mission")) ||
      items[0] ||
      null
    );
  }
  const ourMission = findOurMission(coreValues);
  const missionTitle = ourMission?.title || "Our Mission";
  const missionDescription =
    ourMission?.description ||
    "<p>To deliver innovative, scalable, and resilient software solutions and industry-standard technical training that accelerate human and enterprise potential.</p>";

  const pillars = [
    {
      icon: Users,
      title: "Expert Engineering Squad",
      description:
        "Our dedicated team brings senior industry experience, agile methodology, and creative problem-solving to every solution.",
    },
    {
      icon: Award,
      title: "Quality Assurance & Rigor",
      description:
        "We maintain the highest engineering standards through rigorous automated testing, code review, and attention to detail.",
    },
    {
      icon: TrendingUp,
      title: "Scalable Architecture",
      description:
        "We craft forward-thinking digital architectures that scale seamlessly with business growth and technological evolution.",
    },
    {
      icon: CheckCircle2,
      title: "Client-Centric SLAs",
      description:
        "Your milestone success is our priority. We partner closely through transparent communication and post-launch guarantees.",
    },
  ];

  return (
    <section className="cht-py-14 sm:cht-py-20 cht-bg-white cht-border-y cht-border-slate-200/80 !cht-font-body">
      <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
        {/* Header Section */}
        <div className="cht-text-center cht-max-w-3xl cht-mx-auto cht-mb-12 sm:cht-mb-16">
          <div className="cht-inline-flex cht-items-center cht-gap-2 cht-px-3.5 cht-py-1.5 cht-bg-blue-50 cht-border cht-border-blue-100 cht-rounded-full cht-text-xs !cht-font-bold cht-text-[#3e57da] cht-mb-4">
            <span>About Codehub Technologies</span>
          </div>
          <h2 className="!cht-font-heading cht-text-2xl sm:cht-text-3xl md:cht-text-4xl !cht-font-extrabold cht-text-[#1e293b] cht-tracking-tight cht-mb-4">
            Pioneering Digital Excellence & Engineering Mastery
          </h2>
          <p className="!cht-font-body cht-text-sm sm:cht-text-base cht-text-slate-600 cht-leading-relaxed">
            Codehub Technologies is a premier software engineering and training
            company specializing in scalable web, mobile, and enterprise cloud
            applications. Our mission is to empower businesses and learners to
            thrive in the modern digital economy.
          </p>
        </div>

        {/* Split Content Section */}
        <div className="cht-grid lg:cht-grid-cols-12 cht-gap-10 lg:cht-gap-12 cht-items-center">
          {/* Mission Statement (5 cols) */}
          <div className="lg:cht-col-span-5 cht-space-y-4">
            <div className="cht-rounded-[24px] cht-border cht-border-slate-200/80 cht-shadow-soft cht-bg-[#f8fafc]/80 cht-p-6 sm:cht-p-8">
              <h3 className="!cht-font-heading cht-text-xl sm:cht-text-2xl !cht-font-extrabold cht-text-[#1e293b] cht-tracking-tight cht-mb-3">
                {missionTitle}
              </h3>
              <div className="!cht-font-body cht-text-sm sm:cht-text-base cht-text-slate-700 cht-leading-relaxed cht-prose cht-max-w-none">
                {parse(`${missionDescription}`)}
              </div>
            </div>
          </div>

          {/* Pillars 4-Card Grid (7 cols) */}
          <div className="lg:cht-col-span-7">
            <div className="cht-grid sm:cht-grid-cols-2 cht-gap-5">
              {pillars.map((pillar, idx) => {
                const IconComp = pillar.icon;
                return (
                  <div
                    key={idx}
                    className="cht-rounded-[20px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft cht-p-6 cht-flex cht-flex-col cht-justify-between cht-transition-all cht-duration-300 hover:cht-border-[#3e57da]/50 hover:cht-shadow-md hover:-cht-translate-y-1 group"
                  >
                    <div>
                      <div className="cht-inline-flex cht-items-center cht-justify-center cht-w-11 cht-h-11 cht-rounded-xl cht-bg-blue-50 cht-border cht-border-blue-100 cht-text-[#3e57da] cht-mb-4 group-hover:cht-scale-110 cht-transition-transform">
                        <IconComp size={20} />
                      </div>
                      <h4 className="!cht-font-heading cht-text-base !cht-font-bold cht-text-slate-900 cht-mb-2">
                        {pillar.title}
                      </h4>
                      <p className="!cht-font-body cht-text-xs sm:cht-text-sm cht-text-slate-600 cht-leading-relaxed cht-mb-0">
                        {pillar.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Aboutcard;
